export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-v1-960-9c6a93f702cf73f4ed4360451dc58ea3.png";